(function () {
    'use strict';

    var footerPage = {
        transclude: true,
        templateUrl: 'app/components/footer/footer.html',
        controller: footerPageController,
        controllerAs: 'vm'
    }

    angular
        .module('completeAir')
        .component('footerPage', footerPage);

    function footerPageController(){
        var vm = this;

        vm.$onInit = function(){
            vm.dateCurrent = new Date();
        }

    }

})();
